module.exports = __webpack_public_path__ + "static/media/icon_codescan.5486db16.svg";